module.exports = __webpack_public_path__ + "static/img/shidianban.c5bc223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/shidianban.jpg
// module id = lleX
// module chunks = 0